export const data_table_departamentos_carregando_dados = {
  computed: {
    data_table_departamentos_carregando_dados: {
      get() {
        return this.$store.getters["loading_geral/ativo"];
      },
      set(valor) {
        this.$store.dispatch("loading_geral/ativo", valor);
      },
    }
  }
};
